import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import logo from '../assets/img/myGuardianLinklogo.png';
import { adminLoginApi } from "../api/auth.api";
import { apiHandler } from "../utils/apiHandler";

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    function onKeyDown(e) {
      if (e.key === 'Enter') handleLogin();
    }
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  });

  async function handleLogin() {

    console.log("Login clicked");

  setError('');
  setSuccess(false);

  if (!email) {
    setError('Please enter your email address.');
    return;
  }

  if (!password) {
    setError('Please enter your password.');
    return;
  }

  try {

    setLoading(true);

    const result = await apiHandler(() =>
      adminLoginApi({
        email,
        password,
      })
    );

    if (!result.success) {
      setError(result.message);
      return;
    }

    const responseData = result.data?.data ?? result.data;

    // Save token
    localStorage.setItem(
      "adminToken",
      responseData.token
    );

    // Save admin data
    localStorage.setItem(
      "adminData",
      JSON.stringify(responseData.admin)
    );

    setSuccess(true);

    setTimeout(() => {
      navigate("/dashboard");
    }, 1000);

  } catch (err) {

    setError("Login failed");

  } finally {

    setLoading(false);
  }
}

  function handleSSO() {
    setError('SSO is currently only available for Enterprise accounts. Contact your administrator.');
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--guardian-navy)', display: 'flex', overflow: 'hidden', position: 'relative' }}>
      <div className="bg-pattern" />
      <div className="shield-bg" />
      <div className="shield-bg" />
      <div className="shield-bg" />

      {/* LEFT — Branding */}
      <div className="login-left admin_login">
        <div className="brand-logo">
          <img src={logo} alt="myGuardianLink" />
        </div>
        <div className="divider-line" />
        <h1 className="hero-headline">
          Emergency Response<br /><span>Redefined.</span>
        </h1>
        <p className="hero-sub">
          Staff admin portal for managing users, enrollments, trusted circles, and emergency response operations across the myGuardianLink network.
        </p>
        <div className="stat-row">
          <div className="stat-item">
            <div className="stat-num">53%</div>
            <div className="stat-label">Faster than 911</div>
          </div>
          <div className="stat-item">
            <div className="stat-num">6.75<span style={{ fontSize: 20 }}>min</span></div>
            <div className="stat-label">Avg. response</div>
          </div>
          <div className="stat-item">
            <div className="stat-num">18k+</div>
            <div className="stat-label">Active users</div>
          </div>
        </div>
      </div>

      {/* RIGHT — Login Form */}
      <div className="login-right admin_login">
        <div className="login-card">
          <div className="card-header">
            <div className="card-title">Admin Login</div>
            <div className="card-sub">Sign in to access the Guardian Link admin dashboard</div>
          </div>

          {error && (
            <div className="alert-msg alert-error show">
              <i className="fas fa-circle-exclamation" />
              <span>{error}</span>
            </div>
          )}
          {success && (
            <div className="alert-msg alert-success show">
              <i className="fas fa-circle-check" />
              <span>Login successful! Redirecting…</span>
            </div>
          )}

          <div>
            <div className="form-group">
              <label className="form-label">Email address</label>
              <div className="input-wrap">
                <i className="fas fa-envelope" />
                <input
                  type="email"
                  className="form-input"
                  placeholder="admin@guardianlink.io"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Password</label>
              <div className="input-wrap">
                <i className="fas fa-lock" />
                <input
                  type={showPass ? 'text' : 'password'}
                  className="form-input form-input-right-icon"
                  placeholder="Enter your password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  autoComplete="current-password"
                />
                <button className="input-right-btn" onClick={() => setShowPass(p => !p)} type="button">
                  <i className={`fas ${showPass ? 'fa-eye-slash' : 'fa-eye'}`} />
                </button>
              </div>
            </div>

            <div className="form-meta">
              <label className="remember" onClick={() => setRemember(p => !p)} style={{ cursor: 'pointer' }}>
                <div className={`custom-check${remember ? ' checked' : ''}`} />
                <span className="remember-label">Remember me</span>
              </label>
              <a href="/forgot-password" className="forgot-link">Forgot password?</a>
              {/* <Link to="">
  Forgot password?
</Link> */}
            </div>

            <button className="btn-login" onClick={handleLogin} disabled={loading} style={{ opacity: loading ? 0.8 : 1 }}>
              {loading ? (
                <div className="spinner" style={{ display: 'block' }} />
              ) : (
                <i className="fas fa-shield-halved" />
              )}
              <span>{loading ? 'Authenticating…' : 'Sign In to Admin Portal'}</span>
            </button>
             {/* <button className="btn-login mt-5" disabled={loading} onClick={() => navigate('/register')} style={{ opacity: loading ? 0.8 : 1 }}>
              {loading ? (
                <div className="spinner" style={{ display: 'block' }} />
              ) : (
                <i className="fas fa-shield-halved" />
              )}
               <span  >
                Create Admin Account
              </span>
            </button> */}

            {/* <div className="or-divider">or</div>

            <button className="btn-sso" onClick={handleSSO}>
              <i className="fas fa-key" style={{ fontSize: 13 }} />
              Continue with SSO
            </button> */}
          </div>

          <div className="secure-badge">
            <i className="fas fa-shield-halved" />
            <span>Secured with 256-bit encryption · Admin access only</span>
          </div>

          <div className="card-footer">
            Need access? <a href="#contact">Contact your administrator</a><br style={{ marginBottom: 4 }} />
            <span style={{ marginTop: 6, display: 'block' }}>© 2026 myGuardianLink · <a href="#privacy">Privacy Policy</a></span>
          </div>
        </div>
      </div>
    </div>
  );
}
